import React from 'react';
import Sheet from 'react-modal-sheet';
import {Button, Modal} from 'antd';
import {CloseOutlined} from "@ant-design/icons";

import cls from './CrmTextModal.module.scss';

function CrmTextModal({ isOpen, title, onClose, children }) {
    const isSmallScreenWidth = window.innerWidth <= 425;

    if (isSmallScreenWidth) {
        return (
            <Sheet isOpen={isOpen} onClose={onClose}>
                <Sheet.Container>
                    <Sheet.Header />
                    <Sheet.Content>
                        <div className={cls.sheetTitle}>
                            <h3>{title}</h3>
                            <Button type="link" icon={<CloseOutlined />} onClick={onClose} />
                        </div>
                        <div className={cls.sheetContent}>{children}</div>
                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>
        );
    }

    return (
        <Modal open={isOpen} onCancel={onClose} title={title} footer={null}>
            {children}
        </Modal>
    );
}

export default CrmTextModal;
